'use client'

export function FeedbackWidgetLoader() {
  return null
}
